import { render, staticRenderFns } from "./InterniRadniNalog.vue?vue&type=template&id=2bc8b5f2&scoped=true&"
import script from "./InterniRadniNalog.vue?vue&type=script&lang=ts&"
export * from "./InterniRadniNalog.vue?vue&type=script&lang=ts&"
import style0 from "./InterniRadniNalog.vue?vue&type=style&index=0&id=2bc8b5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8b5f2",
  null
  
)

export default component.exports